import { useEffect, useState } from 'react';
import axiosInstance from '../api/axiosInstance';

const baseUrl = process.env.REACT_APP_API_URL;

const useAuthValidation = () => {
  const [role, setRole] = useState<string>('');
  const token = localStorage.getItem('authToken');

  useEffect(() => {
    const validateToken = async () => {
      try {
        const response = await axiosInstance.get(`${baseUrl}/auth/validate-token`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        setRole(response.data.role);
      } catch (error) {
        console.error('Token error:', error);
      }
    };

    if (token) {
      validateToken();
    }
  }, [token]);

  return role;
};

export default useAuthValidation;
